
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';

@Component
export default class ViewHolder extends Vue {
  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    const title = '入秋啦，上游新闻请你吃火锅';
    const subtitle = '上游新闻联合淘宝闪购，天天抽奖还送优惠券，请你享用秋天的第一顿火锅';
    // App分享
    this.$appShareInfo({
      title,
      url: location.href,
      subtitle,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title,
        subtitle,
        image: cover,
      });
    }
  }
}
